// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bj-0";
export var headerCellHover = "_bj-1";
export var readCellContainer = "_bj-2";
export var readCellSlot = "_bj-3";
export var rowHoverCheckbox = "_bj-4";
export var rowUnreadIndicator = "_bj-5";
export var searchHighlight = "_bj-8";
export var summaryCellHoverWrapper = "_bj-9";
export var supportTicketRow = "_bj-6";
export var unreadIndicator = "_bj-7";